export const lensAddresses = {
  accountLens: "0xA60c4257c809353039A71527dfe701B577e34bc7",
  eulerEarnVaultLens: "0x07d6B3981CBC1DC34102735b987b175116635091",
  irmLens: "0x57B1BB683b109eB0F1e6d9043067C86F0C6c52C1",
  oracleLens: "0x30E6dFB84782A31d561536f64F47231451F7b48A",
  utilsLens: "0x7B89cc2B2607280113c09510353ea6a521e6E0Fc",
  vaultLens: "0x83801C7BbeEFa54B91F8A07E36D81515a0Fc5b60",
} as const
